/*
 * Copyright (c) 2023 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsAlt} from '../theme/theme';
import {IconProps} from '../types/types';

/*
 * Defines the Design Language System (DLS) Poor GPS Icon component.
 */
export const PoorGpsIcon = ({size = 17, iconColor = dlsAlt('maps', 'colors', 'lightOrange')}: IconProps) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={size} height={size} viewBox='0 0 22 22' fill='none'>
      <path d='M9.74985 16.4962C13.3844 16.4962 16.3307 13.5499 16.3307 9.91535C16.3307 6.28083 13.3844 3.33447 9.74985 3.33447C6.11533 3.33447 3.16897 6.28083 3.16897 9.91535C3.16897 13.5499 6.11533 16.4962 9.74985 16.4962Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M9.74996 12.6772C11.2753 12.6772 12.5119 11.4406 12.5119 9.91527C12.5119 8.38989 11.2753 7.15332 9.74996 7.15332C8.22458 7.15332 6.98802 8.38989 6.98802 9.91527C6.98802 11.4406 8.22458 12.6772 9.74996 12.6772Z' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M9.7499 2.91636V1' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M9.7499 18.4999V16.5835' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M2.91636 9.75H1' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <path d='M18.4999 9.75H16.5835' stroke={iconColor} strokeWidth='1.5' strokeMiterlimit='10' strokeLinecap='round'/>
      <circle cx='10.1666' cy='10.167' r='3' fill={iconColor}/>
    </svg>
  );
};

export default PoorGpsIcon;
